import { useCurrentBoxId } from "@/modules/core/store/useCurrentSpaceManagerStore"
import { useUser } from "@/modules/users/hooks/useUser"
import { useProgram } from "@modules/programs/hooks/usePrograms"
import { SharedCoachStatus } from "@modules/programs/types/programTypes"
import { useMemo } from "react"

export const useProgramRights = (programId: string) => {
  const { data: program } = useProgram(programId)
  const user = useUser()
  const boxId = useCurrentBoxId()

  const mySharedCoach = useMemo(() => {
    return user && program.sharedCoaches && program.sharedCoaches.length > 0 && !boxId
      ? program.sharedCoaches.find((coach) => coach.user.id === user.id)
      : undefined
  }, [program.sharedCoaches, boxId, user])

  const isAuthor = useMemo(() => {
    return user && program && program.owner && user.id === program.owner.id && !boxId
  }, [program.owner, user, boxId])

  const isAcceptedSharedCoach = useMemo(() => {
    return !!mySharedCoach && mySharedCoach.status === SharedCoachStatus.ACCEPTED
  }, [mySharedCoach])

  return {
    sharedCoach: mySharedCoach,
    isAuthor: isAuthor ?? false,
    isAcceptedSharedCoach,
  }
}
